import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const withAuth = (extra = {}) => ({
  ...extra,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    ...(extra.headers || {}),
  },
  withCredentials: true,
});

const unwrap = (response) => response?.data?.data ?? response?.data;

export const getCompanies = async (params = {}) => unwrap(
  await axios.get(`${API_URL}/companies`, withAuth({ params }))
);

export const getCompanyBranches = async (companyId) => unwrap(
  await axios.get(`${API_URL}/companies/${companyId}/branches`, withAuth())
);

export const getCompanyProvisioningJobs = async (companyId) => unwrap(
  await axios.get(`${API_URL}/companies/${companyId}/provisioning`, withAuth())
);

export const createCompany = async (payload) => unwrap(
  await axios.post(`${API_URL}/companies`, payload, withAuth())
);

export const updateCompany = async (companyId, payload) => unwrap(
  await axios.patch(`${API_URL}/companies/${companyId}`, payload, withAuth())
);

export const enableCompany = async (companyId) => unwrap(
  await axios.post(`${API_URL}/companies/${companyId}/enable`, {}, withAuth())
);

export const disableCompany = async (companyId) => unwrap(
  await axios.post(`${API_URL}/companies/${companyId}/disable`, {}, withAuth())
);

export const deleteCompany = async (companyId) => unwrap(
  await axios.delete(`${API_URL}/companies/${companyId}`, withAuth())
);

export const restoreCompany = async (companyId) => unwrap(
  await axios.post(`${API_URL}/companies/${companyId}/restore`, {}, withAuth())
);

export const retryCompanyProvisioning = async (companyId) => unwrap(
  await axios.post(`${API_URL}/companies/${companyId}/retry-provisioning`, {}, withAuth())
);
